import {combineReducers} from 'redux';
import navbar from './navbar.reducer';
import message from './message.reducer';
import dialog from './dialog.reducer';
import routes from './routes.reducer';

const fuseReducers = combineReducers({
    navbar,
    message,
    dialog,
    routes
});

export default fuseReducers;
